import * as RadixDialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";

interface DialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	description?: string;
	children: ReactNode;
	footer?: ReactNode;
}

export const Dialog = ({
	open,
	onOpenChange,
	title,
	description,
	children,
	footer,
}: DialogProps) => (
	<RadixDialog.Root open={open} onOpenChange={onOpenChange}>
		<RadixDialog.Portal>
			<RadixDialog.Overlay className="fixed inset-0 z-40 bg-ink/40 backdrop-blur-[1px]" />
			<RadixDialog.Content className="fixed top-1/2 left-1/2 z-50 w-[calc(100vw-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border border-line bg-surface p-5 shadow-xl focus:outline-none">
				<div className="flex items-start justify-between gap-4">
					<div className="space-y-1">
						<RadixDialog.Title className="text-sm font-medium text-ink">{title}</RadixDialog.Title>
						{description ? (
							<RadixDialog.Description className="text-xs text-ink-muted">
								{description}
							</RadixDialog.Description>
						) : null}
					</div>
					<RadixDialog.Close
						aria-label="Close"
						className="flex h-7 w-7 items-center justify-center rounded-md text-ink-muted transition-colors hover:bg-raised hover:text-ink"
					>
						<X className="h-4 w-4" strokeWidth={1.75} />
					</RadixDialog.Close>
				</div>

				<div className="mt-4">{children}</div>
				{footer ? <div className="mt-5 flex justify-end gap-2">{footer}</div> : null}
			</RadixDialog.Content>
		</RadixDialog.Portal>
	</RadixDialog.Root>
);
